/* eslint-disable no-nested-ternary */
// eslint-disable-next-line import/no-extraneous-dependencies
import React from 'react'
import { DARKER_SAVANT_GREEN } from './utils/constants.ts'
import { RemoveButtonProps } from './utils/types.ts'

const OPEN_EYE = (
    <g stroke="white" strokeWidth="1" fill="none">
        <path d="M -4.5 0 C -2 -3.5, 2 -3.5, 4.5 0 C 2 3.5, -2 3.5, -4.5 0 Z" />
        <circle cx={0} cy={0} r={1.5} fill="white" />
    </g>
)

const CROSS_EYE = (
    <g stroke="white" strokeWidth="1" fill="none">
        <path d="M -4.5 0 C -2 -3.5, 2 -3.5, 4.5 0 C 2 3.5, -2 3.5, -4.5 0 Z" />
        <circle cx={0} cy={0} r={1.5} fill="white" />
        <line x1="-4.5" y1="-3.5" x2="4.5" y2="3.5" strokeWidth="1.5" />
    </g>
)

export default function RemoveButton({
    x,
    y,
    symbol,
    isEye,
    isCrossed,
}: RemoveButtonProps) {
    return (
        <g transform={`translate(${x}, ${y})`}>
            <circle
                cx={0}
                cy={0}
                r={6}
                fill={DARKER_SAVANT_GREEN}
                stroke={DARKER_SAVANT_GREEN}
                strokeWidth="2"
            />
            {isEye ? (
                isCrossed ? (
                    CROSS_EYE
                ) : (
                    OPEN_EYE
                )
            ) : (
                <text
                    x={0}
                    y={1}
                    textAnchor="middle"
                    dominantBaseline="middle"
                    fontSize="16"
                    fontWeight="bold"
                    fill="white"
                >
                    {symbol}
                </text>
            )}
        </g>
    )
}
